class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // On pointer devices (desktop), open the menu on hover instead of click.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onHover.bind(this));
      this.addEventListener('mouseleave', this.onLeave.bind(this));

      // Keep a mouse click from toggling the menu shut while hover controls it.
      // Keyboard-triggered clicks (event.detail === 0) still toggle for a11y.
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
        if (event.detail !== 0) event.preventDefault();
      });
    }
  }

  onHover() {
    // Cancel any pending/running close: the panel sits below the header with a
    // gap, so moving the pointer from the item down into the panel briefly
    // leaves this element. Re-entering (over the panel, a descendant) keeps it
    // open, and aborts an exit animation already in progress.
    clearTimeout(this.closeTimer);
    clearTimeout(this.closeAnim);
    this.mainDetailsToggle.classList.remove('mega-menu--closing');

    // Close any other menu immediately so two panels are never open at once
    // while moving between items (a new panel takes the old one's place).
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) {
        clearTimeout(menu.closeTimer);
        clearTimeout(menu.closeAnim);
        menu.mainDetailsToggle.classList.remove('mega-menu--closing');
        menu.close();
      }
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onLeave() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.animateClose(), 200);
  }

  // Play the exit transition while <details> is still [open] (so the browser
  // keeps the panel rendered), then remove [open] once it has faded out —
  // otherwise the content is hidden instantly and the close would snap.
  animateClose() {
    const details = this.mainDetailsToggle;
    if (!details.hasAttribute('open')) return;
    details.classList.add('mega-menu--closing');
    clearTimeout(this.closeAnim);
    this.closeAnim = setTimeout(() => {
      details.classList.remove('mega-menu--closing');
      this.close();
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
